import { render, staticRenderFns } from "./controlbiologico.vue?vue&type=template&id=47f01b64&scoped=true"
import script from "./controlbiologico.vue?vue&type=script&lang=js"
export * from "./controlbiologico.vue?vue&type=script&lang=js"
import style0 from "./controlbiologico.vue?vue&type=style&index=0&id=47f01b64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f01b64",
  null
  
)

export default component.exports